import { useQuery, useMutation } from '@tanstack/react-query';
import { getLogs, exportLogs } from '@/api/endpoints/logs';
import type { LogLevel } from '@/types/log.types';

interface UseLogsOptions {
  deviceId?: string;
  level?: LogLevel;
  dateRange?: {
    start: string;
    end: string;
  };
  page?: number;
  limit?: number;
}

export const useLogs = (options?: UseLogsOptions) => {
  return useQuery({
    queryKey: ['logs', options],
    queryFn: () => getLogs(options),
    staleTime: 1000 * 60,
    retry: 1,
  });
};

export const useExportLogs = () => {
  return useMutation({
    mutationFn: (params?: UseLogsOptions) => exportLogs(params),
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `logs-${new Date().toISOString()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
  });
};
